/**
 * modal
 */

export function modal() {

  document.addEventListener('DOMContentLoaded', function(){

    function handleResize(index) {
      var modalId = modalBtns[index].getAttribute('data-modal');
      if (modalId !== 'modal_search') {
        var modal = document.getElementById(modalId);
      }
    }

    const modalBtns = document.querySelectorAll('.js-modal-open');
    modalBtns.forEach(function (btn, index) {
      btn.onclick = function () {
        var modalId = btn.getAttribute('data-modal');
        var modal = document.getElementById(modalId);
        if (modal) {
          // モーダルを表示
          modal.style.display = "block";
        }
        handleResize(index); // クリック時にもサイズを取得
      };
    });

    const closeBtns = document.querySelectorAll('.modal-close');
    closeBtns.forEach(function (btn) {
      btn.onclick = function () {
        var modal = btn.closest('.c-modal');
        if (modal) {
          modal.style.display = "none";
        }
      };
    });

    window.onclick = function (event) {
      if (event.target.classList.contains('c-modal')) {
        event.target.style.display = "none";
      }
    };

    // ウィンドウのリサイズイベントに対応
    window.addEventListener('resize', function() {
      modalBtns.forEach(function (btn, index) {
        handleResize(index);
      });
    });
  });
}
